var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { css, injectGlobal } from 'emotion';
import { withTheme } from 'emotion-theming';
import React, { useContext, useRef } from 'react';
import { withFlightUI } from '../withFlightUI';
export const DropdownMenuContext = React.createContext(undefined);
injectGlobal `
  [data-flight-dropdown-open='false'] [data-flight-dropdown-items] {
    display: none;
  }
`;
const styles = (theme) => css `
  position: relative;

  [data-flight-dropdown-button] {
    padding: 0.5em 1em;
    border: 1px solid ${theme.colors.tablegrey};
    border-radius: 3px;
  }
  [data-flight-dropdown-items] {
    position: absolute;
    position: absolute;
    top: 100%;
    left: 0;
    background: ${theme.colors.white};
    white-space: nowrap;
    display: block;
    z-index: 2;
    outline: none;
  }
  [data-flight-dropdown-item] {
    cursor: pointer;
    border-top: 1px solid ${theme.colors.tablegrey};
    white-space: nowrap;
    padding: 0.5em 1em;
    :hover {
      color: ${theme.colors.highlight};
    }
  }
`;
export const DropdownMenu = withTheme(function DropdownMenu(_a) {
    var { initialOpen = false, unstyled, children } = _a, rest = __rest(_a, ["initialOpen", "unstyled", "children"]);
    const [isOpen, setIsOpen] = React.useState(initialOpen);
    const [selectedIndex, setSelectedIndex] = React.useState(0);
    const itemRefs = useRef([]);
    const value = React.useMemo(() => {
        return {
            isOpen,
            setIsOpen,
            selectedIndex,
            setSelectedIndex,
            itemRefs,
            // We're copying the theme in to the state so that it can be accessed in
            // child components without using withTheme everywhere. Emotion does not
            // expose the ThemeContext in v9, but in v10 it does, so we could remove
            // this after upgrading.
            theme: rest.theme
        };
    }, [isOpen, rest.theme, selectedIndex]);
    return withFlightUI(React.createElement(DropdownMenuContext.Provider, { value: value }, typeof children === 'function'
        ? children({ isOpen, setIsOpen })
        : children), Object.assign({ as: 'div', 'data-flight-dropdown': '', 'data-flight-dropdown-open': isOpen, role: 'menu', unstyled,
        styles }, rest));
});
DropdownMenu.displayName = 'withFlightUI(DropdownMenu)';
export function useDropdownMenu() {
    const { isOpen, setIsOpen } = useContext(DropdownMenuContext);
    return { isOpen, setIsOpen };
}
//# sourceMappingURL=DropdownMenu.js.map